const column = [
    [{
        type: 'string', role: 'annotation',
    }],
    [{
        type: 'string', role: 'annotationText',
    }],
]

const createChartColumns = (sensorLabels, measurement: string) => {
    return sensorLabels ? sensorLabels.reduce((arr, label) => {
        arr.push(
            [
                'number',
                `${label} [${measurement}]`,
            ],
            ...column,
        )

        return arr
    }, []) : []
}

export default createChartColumns
